registerComponent("templates/cookiebar-redesign", function (component) {
/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} component - Elemento DOM que seleciona o componente em si
 *
 * A versão da política vem de `data-version` no markup (no site novo era o
 * `params` do `Component.define`, que não existe neste runtime): mudá-la exige
 * novo consentimento de quem já tinha respondido.
 *
 * Consentimento LGPD: opt-in por categoria (necessários/análise/marketing), com
 * rejeitar tão acessível quanto aceitar. As escolhas viram sinais do Google
 * Consent Mode v2 via gtag('consent', 'update') (stub definido no _base.html)
 * e o evento "consent.updated" no document (hook para o projeto carregar pixels
 * e outros scripts só com consentimento de marketing).
 * Um link/botão com [data-cookie-prefs] (ex.: no footer) reabre as preferências.
 */

const $component            = $(component);
const $btnAccept     = $component.find('.btn-accept');
const $btnReject     = $component.find('.btn-reject');
const $btnPrefs      = $component.find('.btn-prefs');
const $btnSave       = $component.find('.btn-save');
const $prefsPanel    = $component.find('.cookiebar-prefs');
const $prefAnalytics = $component.find('.pref-analytics');
const $prefMarketing = $component.find('.pref-marketing');

const COOKIE_NAME    = 'cookieConsent';
const POLICY_VERSION = Number(component.dataset.version) || 1;
// O cookiebar legado (`cookieOptin`) continua nas 19 páginas até o cut-over.
// Quem já aceitou lá não é perguntado de novo aqui — ver §Riscos do programa.
const LEGACY_COOKIE  = 'cookieOptin';
// ~6 meses: validade de consentimento recomendada para LGPD
const EXPIRE_DAYS    = 182;

const stored = readConsent();

if (stored) {
    $component.addClass('hidden');
} else {
    gsap.from($component, { duration: 0.4, y: '110%' });
}

$btnAccept.on('click', () => saveConsent({ analytics: true, marketing: true }));

$btnReject.on('click', () => saveConsent({ analytics: false, marketing: false }));

$btnSave.on('click', () => saveConsent({
    analytics: $prefAnalytics.prop('checked'),
    marketing: $prefMarketing.prop('checked'),
}));

$btnPrefs.on('click', () => togglePrefs());

// Reabre a barra para revisar o consentimento (obrigação LGPD de permitir revogação)
$(document).on('click', '[data-cookie-prefs]', function (e) {
    e.preventDefault();

    const current = readConsent();

    $prefAnalytics.prop('checked', !!(current && current.analytics));
    $prefMarketing.prop('checked', !!(current && current.marketing));

    $component.removeClass('hidden');
    togglePrefs(true);
    gsap.from($component, { duration: 0.4, y: '110%' });
});

function togglePrefs(force) {
    const expand = typeof force === 'boolean' ? force : $btnPrefs.attr('aria-expanded') !== 'true';

    $btnPrefs.attr('aria-expanded', String(expand));
    $prefsPanel.prop('hidden', !expand);
}

function saveConsent(choices) {
    const value = {
        v: POLICY_VERSION,
        analytics: !!choices.analytics,
        marketing: !!choices.marketing,
        ts: Date.now(),
    };

    const expires = new Date(Date.now() + EXPIRE_DAYS * 24 * 60 * 60 * 1000);

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;

    applyConsent(value);

    gsap.to($component, {
        duration: 0.4,
        y: '110%',
        onComplete() {
            $component.addClass('hidden');
            gsap.set($component, { clearProps: 'transform' });
            togglePrefs(false);
        },
    });
}

function applyConsent(value) {
    const granted = (ok) => (ok ? 'granted' : 'denied');

    // Sinais do Google Consent Mode v2 (o stub de gtag do _base.html existe
    // sempre, com ou sem GA4 configurado)
    gtag('consent', 'update', {
        'ad_storage':         granted(value.marketing),
        'ad_user_data':       granted(value.marketing),
        'ad_personalization': granted(value.marketing),
        'analytics_storage':  granted(value.analytics),
    });

    // Dado passado direto (sem array): o cash entrega o segundo argumento do
    // trigger literal ao handler, diferente do jQuery que espalhava o array
    $(document).trigger('consent.updated', value);
}

function readConsent() {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));

    if (!match) {
        // Coexistência com o cookiebar legado: `cookieOptin` presente vale como
        // "aceitou tudo". Sem isso quem já respondeu no site antigo é perguntado
        // de novo ao chegar numa página nova.
        return document.cookie.match(new RegExp('(?:^|;\\s*)' + LEGACY_COOKIE + '=([^;]*)'))
            ? { v: POLICY_VERSION, analytics: true, marketing: true, ts: 0 }
            : null;
    }

    try {
        const value = JSON.parse(decodeURIComponent(match[1]));

        // Nova versão da política exige novo consentimento
        return value && value.v === POLICY_VERSION ? value : null;
    } catch (e) {
        return null;
    }
}

});
